import { render, staticRenderFns } from "./DatabaseViewDetail.vue?vue&type=template&id=e76caf0e"
import script from "./DatabaseViewDetail.vue?vue&type=script&lang=js"
export * from "./DatabaseViewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports